import { EU_COUNTRIES } from '@/eu-countries'
import { MIN_MD_SCREEN_WIDTH } from '@/constants'

export default {
  dataProcessingConsentField: (state) => {
    return state.fields.find((f) => f.name === 'euDataProcessingConsent')
  },

  dataProcessingConsentLabel: (state, getters) => {
    const fieldConfig = getters.dataProcessingConsentField

    if (!fieldConfig) {
      return null
    }

    return fieldConfig.label
  },

  fieldWasSetFromCrm: (state) => (fieldName) => {
    return state.fieldsSetFromCrm.indexOf(fieldName) !== -1
  },

  fieldValue: (state) => (fieldName) => {
    const matchingField = state.fields.find((f) => f.name === fieldName)

    if (!matchingField) {
      throw `invalid field name ${fieldName}`
    }

    if (matchingField.isAdditionalField) {
      return state.action.additionalFields[fieldName]
    } else {
      return state.action[fieldName]
    }
  },

  isSubscribedInCrm: (state) => {
    return state.globalSubscriptionCheck.email === state.action.email && state.globalSubscriptionCheck.isSubscribed
  },

  oneClickSigning: (state) => {
    return state.oneClickFromContext || state.oneClickFromCrm
  },

  shouldShowDataProcessingConsent: (state, getters) => {
    const fieldConfig = getters.dataProcessingConsentField
    if (!fieldConfig) {
      return null
    }

    if (fieldConfig.countryToggles && state.action.country) {
      return EU_COUNTRIES.includes(state.action.country)
    } else {
      return true
    }
  },

  showDataProcessingConsentAfterSubmit: (state, getters) => {
    // If we shouldn't show data processing consent at all, then we should not show the message
    if (!getters.shouldShowDataProcessingConsent) {
      return false
    }

    const fieldConfig = getters.dataProcessingConsentField

    // For explicit consent, we never show a message after the submit button
    if (fieldConfig.explicitConsentRequired) {
      return false
    }

    // If the message is configured for the "after submit" position, show it
    return fieldConfig.messagePosition === 'after_submit'
  },

  showSidebarForScreenSize: (state) => {
    return state.windowWidth >= MIN_MD_SCREEN_WIDTH
  },

  suppressEmailOptInField: (state) => {
    return state.globalSubscriptionCheck.suppressEmailOptInFieldIfCrmLookupFails && state.globalSubscriptionCheck.crmLookupFailed
  }
}
